import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideTemplateForm from '../containers/CareGuideTemplateFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideTemplateAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideTemplateAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_template_route_add')} />
          <CareGuideTemplateForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideTemplateAddScreen;

Logger.log('silly', `CareGuideTemplateAddScreen loaded.`);
